import React, { Fragment, PureComponent, memo } from "react";

import DatePicker from "../../components/UI/DatePicker/DatePicker";
import ComboBox from "../../components/UI/comboBox/combobox.jsx";
import CheckBox from "../../components/UI/checkBox/checkBox.jsx";
import ComboBoxMulti from '../../components/UI/comboBox/comboboxmulti.jsx';

import { Button, Row, Col, Container, FormGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronUp,
    faChevronDown,
    faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";

class ReporteIntfz extends PureComponent {
    componentDidMount = () => { };

    componentWillUnmount = () => { };

    render() {
        let {
            titulo,
            descripcion,
            Datos,
            selectedCallCenter,
            listaCallCenter,
            selectedSucursales,
            listaSucursales,
            listaEstatus,
            selectedEstatus,
        } = this.props;
        return (
            <div className="main">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <h1>{titulo}</h1>
                            <p>{descripcion}</p>
                        </div>
                    </div>
                    <div className="content-bg">
                        <div className="row">
                            <div className="col">
                                <ComboBox
                                    id="CC_id"
                                    label={Datos.CC_id.attributes.label}
                                    attributes={Datos.CC_id.attributes}
                                    value={selectedCallCenter}
                                    datos={listaCallCenter}
                                    onChange={this.props.onhandleSelectedOption}
                                />
                            </div>
                            <div className="col">
                                <ComboBox
                                    id="Estatus"
                                    label={Datos.Estatus.attributes.label}
                                    attributes={Datos.Estatus.attributes}
                                    value={selectedEstatus}
                                    datos={listaEstatus}
                                    onChange={this.props.onhandleSelectedEstatus}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <ComboBoxMulti
                                    id="selectedSucursales"
                                    attributes={Datos.Sucursal.attributes}
                                    value={selectedSucursales}
                                    label={Datos.Sucursal.attributes.label}
                                    datos={listaSucursales}
                                    onChange={this.props.onhandleSelectSucursales}
                                    placeholder={'Seleccione'}
                                     />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label>Fecha Inicio:</label>
                                    <DatePicker
                                        name="FechaInicio"
                                        value={Datos.FechaInicio.value}
                                        onChange={this.props.onChangeDate}
                                        props={{}}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <label>Fecha Final:</label>
                                    <DatePicker
                                        name="FechaFinal"
                                        value={Datos.FechaFinal.value}
                                        onChange={this.props.onChangeDate}
                                        props={{ maxDate: new Date() }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col mt-2">
                                <CheckBox
                                    id="IncluirResumen"
                                    attributes={Datos.IncluirResumen.attributes}
                                    value={Datos.IncluirResumen.value}
                                    label={Datos.IncluirResumen.attributes.label}
                                    onChange={this.props.handleCheckBox}
                                />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col text-right">
                                <div className="tooltip2">
                                    <span className="tooltiptext2">Cancelar</span>
                                    <button
                                        className="btn btn-link-secondary"
                                        onClick={this.props.volverAtras}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                                <div className="tooltip2">
                                    <span className="tooltiptext2">Ver Reporte</span>
                                    <button
                                        className="btn btn-primary"
                                        onClick={this.props.onGenerarReporte}
                                    >
                                        Ver Reporte
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReporteIntfz;
